import { Card } from "reactstrap";
import { Fragment, useState, useEffect } from 'react'
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { Btn, H4, P } from '../../../AbstractElements';
import { Address, EmailAddress, FirstName, Gender, LastName } from '../../../utils/Constant';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addPatientAction } from "../../../Api/patient";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import { getClinicianInfo } from "../../../Api/auth";
import GeneratingLoader from "../../../CommonElements/GeneratingLoader/GeneratingLoader";

const PatientFormContainer = () => {
  const navigate = useNavigate();
  const user = useAppSelector(state => state.user)
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [parentFirstName, setParentFirstName] = useState("")
  const [parentlastName, setParentLastName] = useState("")
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [birthday, setBirthday] = useState("");
  const [school, setSchool] = useState("");
  const [teacherEmail, setTeacherEmail] = useState("");
  const [gpEmail, setGPEmail] = useState("");
  const [treatingClinicEmail, setTreatingClinicEmail] = useState("");
  const [type, setType] = useState("adult");
  const [clinicians, setClinicians] = useState<any>([])
  const [clinicianId, setClinicianId] = useState("")
  const [clinicianEmail, setClinicianEmail] = useState("")
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchClinicianInfo = async () => {
      const response: any = await getClinicianInfo()
      setClinicians(response.payload)
    }
    if (user.role === "admin") {
      fetchClinicianInfo();
    }
  }, [user])

  const addPatientHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const _patient = {
      firstname, lastname, email, type, gender, address, phonenumber, birthday, school, teacher_email: teacherEmail, gp_email: gpEmail, treating_clinic_email: treatingClinicEmail, parentFirstName, parentlastName, clinicianId, clinicianEmail
    }
    setLoading(true)
    const response = await addPatientAction(_patient)

    if (response.data.status === "success") {
      toast.success(response.data.message)
      setLoading(false)
    }
    else
      toast.error("Register failed!")
  };

  const handleChangeClinician = (event: any) => {
    setClinicianId(event)
    setClinicianEmail(clinicians.filter((item: any) => item.id === event)[0].email)
  }

  return (
    <div className='w-100 d-flex align-items-center justify-content-center py-5' style={{ minHeight: '100vh' }}>
      {loading && <GeneratingLoader label="Loading..." />}
      <Card className="overflow-hidden mx-3 w-100 mb-0 px-5 py-4" style={{ maxWidth: 800 }}>
        <div>
          <div className="login-main">
            <Form className="theme-form" onSubmit={(event) => addPatientHandle(event)}>
              <H4>{"Patient Information"}</H4>
              <P>{"Please enter all the information below"}</P>
              <FormGroup>
                <Label className="col-form-label pt-0">{"Patient Type"}</Label>
                <div className="form-check-size rtl-input">
                  <div className="form-check form-check-inline cursor-pointer">
                    <Input className="border me-2" id="patient_adult" type="radio" name="patient_adult" value="adult" checked={type === "adult"} onChange={(e) => setType(e.target.value)} />
                    <Label for='patient_adult' style={{ cursor: "pointer" }} check>Adult</Label>
                  </div>
                  <div className="form-check form-check-inline">
                    <Input className="border me-2" id="patient_child" type="radio" name="patient_child" value="child" checked={type === "child"} onChange={(e) => setType(e.target.value)} />
                    <Label for='patient_child' style={{ cursor: "pointer" }} check>Child</Label>
                  </div>
                </div>
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label pt-0">{"Patient Name"}</Label>
                <Row className="g-2">
                  <Col xs="6">
                    <Input type="text" required placeholder={FirstName} onChange={(event) => setFirstName(event.target.value)} />
                  </Col>
                  <Col xs="6">
                    <Input type="text" required placeholder={LastName} onChange={(event) => setLastName(event.target.value)} />
                  </Col>
                </Row>
              </FormGroup>
              {
                type === 'child' &&
                <FormGroup>
                  <Label className="col-form-label pt-0">{"Parents Name"}</Label>
                  <Row className="g-2">
                    <Col xs="6">
                      <Input type="text" required placeholder={parentFirstName} onChange={(event) => setParentFirstName(event.target.value)} />
                    </Col>
                    <Col xs="6">
                      <Input type="text" required placeholder={parentlastName} onChange={(event) => setParentLastName(event.target.value)} />
                    </Col>
                  </Row>
                </FormGroup>
              }
              {
                user.role === "admin" && <FormGroup>
                  <Label className="col-form-label">{"Clinicians"}</Label>
                  <Input type="select" required onChange={(event) => handleChangeClinician(event.target.value)}>
                    <option value="" disabled selected>---Please choose a clinician---</option>
                    {
                      clinicians.map((item: any, index: number) => {
                        return (
                          <option key={index} value={item.id}>{`${item.firstname} ${item.lastname} — ${item.email}`}</option>
                        )
                      })
                    }
                  </Input>
                </FormGroup>
              }
              <Label className="col-form-label">{Gender}</Label>
              <div className="form-check-size rtl-input">
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_male" type="radio" name="gender_male" value="male" checked={gender === "male"} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_male' style={{ cursor: "pointer" }} check>Male</Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_female" type="radio" name="gender_female" value="female" checked={gender === "female"} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_female' style={{ cursor: "pointer" }} check>Female</Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input className="border me-2" id="gender_prefer_not_say" type="radio" name="gender_prefer_not_say" value="" checked={!gender} onChange={(e) => setGender(e.target.value)} />
                  <Label for='gender_prefer_not_say' style={{ cursor: "pointer" }} check>Prefer not to say</Label>
                </div>
              </div>
              <FormGroup>
                <Label className="col-form-label">{Address}</Label>
                <Input type="text" required placeholder={"Address"} onChange={(event) => setAddress(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{type === 'adult' ? EmailAddress : "Parent Email Address"}</Label>
                <Input type="email" required placeholder={"example@gmail.com"} onChange={(event) => setEmail(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{type === 'adult' ? "Phone Number" : "Parent Phone Number"}</Label>
                <Input type="text" required placeholder={"+61 612 551 578 "} onChange={(event) => setPhoneNumber(event.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label className="col-form-label">{"Date of Birth"}</Label>
                <Input type="date" required placeholder={"example@gmail.com"} onChange={(event) => setBirthday(event.target.value)} />
              </FormGroup>
              {type === 'child' &&
                < Fragment >
                  <FormGroup>
                    <Label className="col-form-label">{"School"}</Label>
                    <Input type="text" placeholder={"Willetton Senior High School"} onChange={(event) => setSchool(event.target.value)} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{"Teacher Email (Optional)"}</Label>
                    <Input type="email" placeholder={"example@gmail.com"} onChange={(event) => setTeacherEmail(event.target.value)} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{"GP Email (Optional)"}</Label>
                    <Input type="email" placeholder={"example@gmail.com"} onChange={(event) => setGPEmail(event.target.value)} />
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">{"Treating Clinic Email (Optional)"}</Label>
                    <Input type="email" placeholder={"example@gmail.com"} onChange={(event) => setTreatingClinicEmail(event.target.value)} />
                  </FormGroup>
                </Fragment>
              }
              <FormGroup className="mb-0 mt-5 d-flex justify-content-end">
                <div className="d-flex justify-content-right" style={{ gap: 8, width: "100%", maxWidth: 500 }}>
                  <Btn onClick={() => navigate(-1)} color="primary" className="w-100 btn btn-secondary">{"Patients List"}</Btn>
                  <Btn block color="primary" className="w-100" >{"Submit"}</Btn>
                </div>
              </FormGroup>
            </Form>
          </div>
        </div>
      </Card >
    </div >
  )
}

export default PatientFormContainer